import { QConfigGeneratorExecutionStatus } from '@exam-management/graphql';
import { type GridColDef, Text, Label, EllipsisText } from '@shared/components';
import { formatDateTime } from '@shared/utils';

export interface QConfigGenerator {
  id: string;
  code: string;
  name: string;
  count: number | null;
  status: QConfigGeneratorExecutionStatus;
  createAt: Date | undefined;
}

function renderStatusCell(status: QConfigGeneratorExecutionStatus) {
  switch (status) {
    case QConfigGeneratorExecutionStatus.Pending:
    case QConfigGeneratorExecutionStatus.Processing:
      return (
        <Label color='warning' variant='outlined' size='large'>
          Generating
        </Label>
      );
    case QConfigGeneratorExecutionStatus.Done:
    case QConfigGeneratorExecutionStatus.Failed:
      return (
        <Label color='success' variant='outlined' size='large'>
          Completed
        </Label>
      );
    default:
      return null;
  }
}

export const columns: GridColDef<QConfigGenerator>[] = [
  {
    field: 'code',
    headerName: 'ID',
    width: 120,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => {
      return <Text>{params.row.code}</Text>;
    },
  },
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    sortable: false,
    renderCell: (params) => {
      return (
        <EllipsisText maxLines={2} variant='body1Semibold'>
          {params.row.name}
        </EllipsisText>
      );
    },
  },
  {
    field: 'count',
    headerName: 'Generated Count',
    width: 160,
    sortable: false,
    renderCell: (params) => {
      return <EllipsisText maxLines={2}>{params.row.count ?? '-'}</EllipsisText>;
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    sortable: false,
    width: 140,
    renderCell: (params) => {
      return renderStatusCell(params.row.status);
    },
  },
  {
    field: 'createAt',
    headerName: 'Generated at',
    width: 160,
    renderCell: (params) => {
      return <Text>{formatDateTime(params.row.createAt)}</Text>;
    },
  },
];
